import { useState, useEffect, useContext } from 'react'
import StartSelection from './StartSelection'
import {
  UserContextProvider,
  SocketContextProvider,
  ScrollContextProvider,
  ReportContextProvider,
  ModeContextProvider,
  EditingContextProvider,
  GuardiaContextProvider
} from './Context'
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { lightTheme } from '../theme/muiTheme';

function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <ReportContextProvider>
        <UserContextProvider>
          <SocketContextProvider>
            <ScrollContextProvider>
              <ModeContextProvider>
                <EditingContextProvider>
                  <GuardiaContextProvider>
                    <StartSelection />
                  </GuardiaContextProvider>
                </EditingContextProvider>
              </ModeContextProvider>
            </ScrollContextProvider>
          </SocketContextProvider>
        </UserContextProvider>
      </ReportContextProvider>
    </ThemeProvider>
  )
}

export default App